import { API, standardResponse } from "./middleware";

export async function loginToGetToken(username, password) {
  const url = "/api/auth/login";
  const params = {
    username,
    password,
  };

  return API.post(url, params)
    .then((response) => {
      // eslint-disable-next-line no-console
      console.log(response.data.token);
      return response.data.token;
    })
    .catch((error) => standardResponse(false, error.response?.data));
}
export async function getListUser() {
  const url = "/api/user/listAll";
  return API.get(url)
    .then((response) => response.data)
    .catch((error) => console.error(error.message));
}

export async function AddUserApi(userData) {
  const url = "/api/users/create";
  // eslint-disable-next-line no-console
  console.log("userData", userData); // Kiểm tra log để đảm bảo partnerId được gửi đúng
  return API.post(url, userData)
    .then((response) => {
      // eslint-disable-next-line no-console
      console.log(response.data);
      return response.data;
    })
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function AddUsersApi(userData) {
  const url = "/api/user/addUsers";
  return API.post(url, userData)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function SyncUser() {
  const url = "/api/user/sync";
  return API.get(url)
    .then((response) => {
      // eslint-disable-next-line no-console
      console.log(response.data);
      return response.data;
    })
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function EditUserApi(userData) {
  const url = "/api/users/update";
  return API.post(url, userData)
    .then((response) => {
      // eslint-disable-next-line no-console
      console.log(response.data);
      return response.data;
    })
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function EditSelfUserApi(userData) {
  const url = "/api/user/updateSelf";
  return API.post(url, userData)
    .then((response) => {
      // eslint-disable-next-line no-console
      console.log(response.data);
      return response.data;
    })
    .catch((error) => standardResponse(false, error.response?.data));
}

export const deleteUser = async (id) => {
  let result = {};
  const url = `api/users/delete?id=${id}`;
  await API.get(url)
    .then((response) => {
      standardResponse(true, response);
      result = response;
    })
    .catch((error) => {
      standardResponse(false, error.response?.data);
      // eslint-disable-next-line no-console
      console.log("Lỗi là :", error);
    });
  return result.data;
};

export const lockUser = async (id) => {
  const url = `api/users/lockUser?id=${id}`;
  return API.get(url)
    .then((response) => standardResponse(true, response))
    .catch((error) => standardResponse(false, error.response?.data));
};

export const unlockUser = async (id) => {
  const url = `api/users/unlockUser?id=${id}`;
  return API.get(url)
    .then((response) => standardResponse(true, response))
    .catch((error) => standardResponse(false, error.response?.data));
};

export async function resetPassword(id, password) {
  const url = `api/users/resetPassword?id=${id}&password=${encodeURIComponent(password)}`;
  return API.get(url)
    .then((response) => standardResponse(true, response))
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function resetTwoFA(username) {
  const url = `api/users/resetTwoFA`;
  return API.post(url, username)
    .then((response) => standardResponse(true, response))
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function SearchDataUserWithPagination(dataSearch) {
  const { username, fullName, enabled, page, size, email, phone } = dataSearch;
  let url = "api/users/list?";

  if (username !== null && username !== "") {
    url += `username=${username}&`;
  }
  if (fullName !== null && fullName !== "") {
    url += `fullName=${fullName}&`;
  }
  if (enabled !== null) {
    url += `enabled=${enabled}&`;
  }
  if (page !== null) {
    url += `page=${page}&`;
  }
  if (size !== null) {
    url += `size=${size}&`;
  }
  if (size !== null) {
    url += `size=${size}&`;
  }
  if (email !== null && email !== "") {
    url += `email=${email}&`;
  }
  if (phone !== null && phone !== "") {
    url += `phone=${phone}&`;
  }
  return API.get(url, dataSearch)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function SearchDataUser(dataSearch) {
  const { userID, fullName, enabled, role } = dataSearch;
  let url = "api/user/list?";

  if (userID !== null && userID !== "") {
    url += `userID=${userID}&`;
  }
  if (fullName !== null && fullName !== "") {
    url += `fullName=${fullName}&`;
  }
  if (enabled !== null) {
    url += `enabled=${enabled}&`;
  }
  if (role !== null) {
    url += `role=${role}&`;
  }
  return API.get(url, dataSearch)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function getListRole() {
  const url = `api/role/list`;
  return API.get(url)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function getRoleByUserId(id) {
  const url = `api/user/getRoleByUserId?id=${id}`;
  return API.post(url)
    .then((response) => {
      // eslint-disable-next-line no-console
      console.log("response.data", response.data);
      return response.data;
    })
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function updateRoleUser(item) {
  const url = `api/user/updateRoles`;
  return API.post(url, item)
    .then((response) => standardResponse(true, response))
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function getUserInfo(id) {
  const url = `/api/users/getUserInfo?id=${id}`;
  return API.get(url)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function getUserByUserName(username) {
  const url = `/api/user/getByUsername?username=${username}`;
  return API.get(url)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function findUserByEmail(email) {
  const url = `/api/users/findByEmail?email=${encodeURIComponent(email)}`;
  return API.get(url)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function getUsersByPartnerId() {
  const url = "api/users/listUsersInPartner";
  return API.get(url)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}
export async function getAllUsersByPartnerId() {
  const url = "api/users/listAllUsersInPartner";
  return API.get(url)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function findUsersByPartnerId(partnerId) {
  const url = `api/users/getUsersByPartnerId?partnerId=${partnerId}`;
  return API.get(url)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function loadSelectUser() {
  const url = "api/users/loadSelectUser";
  return API.get(url)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function updateUser(userData) {
  const url = "/api/users/updateUser";
  // eslint-disable-next-line no-console
  console.log("userData", userData); // Kiểm tra log để đảm bảo partnerId được gửi đúng
  return API.post(url, userData)
    .then((response) => {
      // eslint-disable-next-line no-console
      console.log(response.data);
      return response.data;
    })
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function getAllUser() {
  const url = "api/users/getAllActiveUser";
  return API.get(url)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function checkPhoneNumber(phone) {
  const url = `api/users/checkUserByPhoneNumber?phone=${phone}`;
  return API.get(url)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function uploadFile(file) {
  const url = "/api/users/scanCCCD";
  const formData = new FormData();
  formData.append("image", file); // Đúng với @RequestParam("image") trong backend

  return API.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data", // Quan trọng khi gửi FormData
    },
  })
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function importUsersFromExcel(formData) {
  try {
    // Gọi API POST
    const response = await API.post("/api/users/import", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      responseType: "blob", // Để xử lý file trả về (nếu có lỗi)
    });

    // Kiểm tra nội dung phản hồi
    const contentType = response.headers["content-type"];
    if (contentType.includes("application/json")) {
      // Nếu phản hồi là JSON (nhập khẩu thành công)
      return { status: 200 };
    }

    if (contentType.includes("application/octet-stream")) {
      // Nếu phản hồi là file (nhập khẩu có lỗi)
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "user_import_errors.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      // Thông báo lỗi
      const errorMessage = "Vui lòng kiểm tra lại dữ liệu trong file lỗi.";
      return { status: 201, message: errorMessage };
    }

    throw new Error("Phản hồi từ server không hợp lệ.");
  } catch (error) {
    // Xử lý lỗi từ server hoặc mạng
    let errorMessage = "Lỗi khi gọi API import người dùng.";
    if (error.response) {
      // Lỗi từ server (VD: 400, 500)
      if (error.response.status === 400) {
        const text = await error.response.data.text();
        errorMessage = JSON.parse(text);
      } else if (error.response.status === 500) {
        const text = await error.response.data.text();
        errorMessage = JSON.parse(text);
      }
    } else {
      // Lỗi mạng hoặc client-side
      errorMessage = error.message;
    }
    return { status: 400, message: errorMessage };
  }
}

export async function register(userData) {
  const url = "/api/auth/register";
  return API.post(url, userData)
    .then((response) => {
      console.log(response.data);
      return response.data;
    })
    .catch((error) => standardResponse(false, error.response?.data));
}
export async function validate(userData) {
  const url = "/api/auth/validate";
  return API.post(url, userData)
    .then((response) => {
      console.log(response.data);
      return response.data;
    })
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function changePassword(userData) {
  const url = "/api/auth/changePassword";
  return API.post(url, userData)
    .then((response) => {
      console.log(response.data);
      return response.data;
    })
    .catch((error) => standardResponse(false, error.response?.data));
}
